import uppyLocalePtBR from '@uppy/locales/lib/pt_BR'

export default {
    Language: 'Idioma',
    Create: 'Criar',
    Close: 'Fechar',
    Cancel: 'Cancelar',
    Save: 'Salvar',
    Edit: 'Editar',
    Crop: 'Cortar',
    'New Folder': 'Nova Pasta',
    'New File': 'Novo Arquivo',
    Rename: 'Renomear',
    Delete: 'Excluir',
    Upload: 'Enviar',
    Download: 'Baixar',
    Archive: 'Arquivar',
    Unarchive: 'Desarquivar',
    Open: 'Abrir',
    'Open containing folder': 'Abrir pasta contendo',
    Refresh: 'Atualizar',
    Preview: 'Visualizar',
    'Toggle Full Screen': 'Alternar Tela Cheia',
    'Change View': 'Mudar Visualização',
    Storage: 'Armazenamento',
    'Go up a directory': 'Subir um diretório',
    'Search anything..': 'Pesquisar qualquer coisa...',
    Name: 'Nome',
    Size: 'Tamanho',
    Date: 'Data',
    Filepath: 'Caminho do Arquivo',
    'Folder Name': 'Nome da Pasta',
    'File Name': 'Nome do Arquivo',
    'Move files': 'Mover arquivos',
    'Yes, Move!': 'Sim, Mover!',
    'Delete files': 'Excluir arquivos',
    'Yes, Delete!': 'Sim, Excluir!',
    'Upload Files': 'Enviar Arquivos',
    'No files selected!': 'Nenhum arquivo selecionado!',
    'Select Files': 'Selecionar Arquivos',
    'Archive the files': 'Arquivar os arquivos',
    'Unarchive the files': 'Desarquivar os arquivos',
    'The archive will be unarchived at': 'O arquivo será desarquivado em',
    'Archive name. (.zip file will be created)':
        'Nome do arquivo compactado (.zip será criado)',
    'Vuefinder is a file manager component for vue 3.':
        'Vuefinder é um gerenciador de arquivos para Vue 3.',
    'Create a new folder': 'Criar uma nova pasta',
    'Create a new file': 'Criar um novo arquivo',
    'Are you sure you want to delete these files?':
        'Tem certeza de que deseja excluir estes arquivos?',
    'This action cannot be undone.': 'Esta ação não pode ser desfeita.',
    'Search results for': 'Resultados da pesquisa para',
    '%s item(s) selected.': '%s item(ns) selecionado(s).',
    '%s is renamed.': '%s foi renomeado.',
    'This is a readonly storage.': 'Este é um armazenamento somente leitura.',
    '%s is created.': '%s foi criado.',
    'Files moved.': 'Arquivos movidos.',
    'Files deleted.': 'Arquivos excluídos.',
    'The file unarchived.': 'O arquivo foi desarquivado.',
    'The file(s) archived.': 'O(s) arquivo(s) foi/foram arquivado(s).',
    'Updated.': 'Atualizado.',
    'No search result found.': 'Nenhum resultado encontrado.',
    'Are you sure you want to move these files?':
        'Tem certeza de que deseja mover estes arquivos?',
    'File Size': 'Tamanho do Arquivo',
    'Last Modified': 'Última Modificação',
    'Select Folders': 'Selecionar Pastas',
    'Clear all': 'Limpar tudo',
    'Clear only successful': 'Limpar apenas os bem-sucedidos',
    'Drag and drop the files/folders to here or click here.':
        'Arraste e solte os arquivos/pastas aqui ou clique aqui.',
    'Release to drop these files.': 'Solte para enviar os arquivos.',
    Canceled: 'Cancelado',
    Done: 'Concluído',
    'Network Error, Unable establish connection to the server or interrupted.':
        'Erro de rede, não foi possível estabelecer conexão com o servidor ou conexão interrompida.',
    'Pending upload': 'Envio pendente',
    'Please select file to upload first.':
        'Por favor, selecione um arquivo para enviar primeiro.',
    About: 'Sobre',
    Settings: 'Configurações',
    Shortcuts: 'Atalhos',
    Reset: 'Redefinir',
    Escape: 'Esc',
    Search: 'Pesquisar',
    'Toggle Sidebar': 'Alternar Barra Lateral',
    'Open Settings': 'Abrir Configurações',
    'Reset all settings to default':
        'Redefinir todas as configurações para o padrão',
    'Use Metric Units': 'Usar Unidades Métricas',
    'Saved.': 'Salvo.',
    'Reset Settings': 'Redefinir Configurações',
    'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".':
        'O download não está funcionando? Tente clicar com o botão direito no botão "Baixar" e selecionar "Salvar link como...".',
    Theme: 'Tema',
    Dark: 'Escuro',
    Light: 'Claro',
    System: 'Sistema',
    'Target Directory': 'Diretório de Destino',
    Select: 'Selecionar',
    'Compact list view': 'Visualização de lista compacta',
    'Show thumbnails': 'Mostrar miniaturas',
    'Persist path on reload': 'Manter caminho ao recarregar',
    'Select All': 'Selecionar Todos',
    'Pinned Folders': 'Pastas Fixadas',
    'No folders pinned': 'Nenhuma pasta fixada',
    'Pin Folder': 'Fixar Pasta',
    'Unpin Folder': 'Desafixar Pasta',
    'Project home': 'Página do projeto',
    'Follow on GitHub': 'Siga no GitHub',
    'Customize your experience with the following settings':
        'Personalize sua experiência com as seguintes configurações',
    uppy: uppyLocalePtBR,
}
